import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient} from '@angular/common/http';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class ContactRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('contacts');
  }

  getContactTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.getEndpoint(['types']));
  }

  verifyEmaiAddress(token: string): Observable<string> {
    const options = {responseType: 'text' as 'text'};
    return this.http.put(this.getEndpoint(['verify', 'contact-mail', token]), new FormData(), options);
  }

}
